import { Component, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AuthService, CommonService } from '../../../services';

@Component({
    selector: 'app-subcription-expired-dialog',
    imports: [
      MatDialogModule,
      MatButtonModule
    ],
    templateUrl: './subcription-expired-dialog.component.html',
    styleUrl: './subcription-expired-dialog.component.scss'
})
export class SubcriptionExpiredDialogComponent {
  constructor(@Optional() private dialogRef: MatDialogRef<SubcriptionExpiredDialogComponent>,
    private authService: AuthService, private commonService: CommonService) { }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  logout() {
    this.closeDialog();
    this.authService.logout();
  }

  upgrade() {
    this.closeDialog();
    this.commonService.openUpgradePlanPopup.next();
  }

  isTrial(){
    return this.commonService?.subscriptionDetail?.status === 'trial';
  }
}
